export const environment = {
  production: true,
  eng: false,
  analytics: true,
  slackBot: true,
  yandexMetricCounterNumber: 88169871,
  enableOnlineConsultant: true,
};
